export default class HubspotCheck {
	constructor() {
		this.input = document.getElementById('hubSpotOrganizationName');
		this.hubspotId = document.getElementById('hubspotId');
		this.errorMessage = document.getElementById('organizationErrorMessage');
		this.hubspotCheckBtn = document.getElementById('hubspotCheckBtn');

		this.hubspotCheckBtn.addEventListener('click', this.checkOrganization.bind(this));
	}

	async checkOrganization() {
		const inputValue = this.input.value;

		// Only proceed if the input has a value
		if (!inputValue) return;

		const apiUrl = '/umbraco/api/OrganizationInvitationApi/GetHubSpotOrganization';

		try {
			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(inputValue),
			});

			const data = await response.json();

			if (!response.ok) {
				this.hubspotId.value = '';
				this.handleError(response.status);
			}

			if (data.organization) {
				const hubspotId = data.organization?.id;
				this.hubspotId.value = hubspotId;
				this.errorMessage.classList.add('error-msg--hidden');
			} else {
				this.hubspotId.value = '';
				this.errorMessage.classList.remove('error-msg--hidden');
			}
		} catch (error) {
			this.handleError(error.status);
		}
	}

	handleError(status) {
		switch (status) {
			case 400:
				this.errorMessage.textContent = 'HubSpot Organization name is required';
				break;
			case 404:
				this.errorMessage.textContent =
					'Organization could not be found, please check HubSpot for the correct name.';
				break;
			case 500:
				this.errorMessage.textContent =
					'Something went wrong. Please try again later or contact DEV team if this persists.';
				break;
			default:
				this.errorMessage.textContent = 'An error occurred. Please try again later.';
				break;
		}
		this.errorMessage.classList.remove('error-msg--hidden');
	}
}
